module.exports = __webpack_public_path__ + "static/img/logo-domain-desktop@2x.1360056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/domain-custom/base/logo-domain-desktop@2x.png
// module id = 1026
// module chunks = 0